import { localization } from "../../service/languages/languages";
import { useParams } from "react-router-dom";
import { capitalizeFirstLetter } from "../../service/helperFunctions/captalizeFirstLetter";
// type Props = {
//   routeStart: string;
//   routeEnd: string;
// };
export default function RouteDetails() {
  const { routeId } = useParams();
  const routeArray = routeId?.split("_");
  return (
    <div className="h-100 container pt-4 d-flex flex-column align-items-start gap-2 fontLight fw-bold text-2-5 justify-content-center">
      <div className="d-flex gap-1">
        <span>{start}</span>
        <span>
          {routeArray ? (
            capitalizeFirstLetter(routeArray[0])
          ) : (
            <>{localization["No data"]} </>
          )}
        </span>
      </div>
      <div className="w-100 ps-2">{arrow}</div>
      <div className="d-flex gap-1">
        <span>{end}</span>
        <span>
          {routeArray ? (
            capitalizeFirstLetter(routeArray[1])
          ) : (
            <>{localization["No data"]} </>
          )}
        </span>
      </div>
    </div>
  );
}

const start = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.91781 17V15.5445C6.14536 15.3634 4.67047 14.6842 3.49315 13.5069C2.31583 12.3295 1.63661 10.8546 1.45548 9.08219H0V7.91781H1.45548C1.63661 6.14536 2.31583 4.67047 3.49315 3.49315C4.67047 2.31583 6.14536 1.63661 7.91781 1.45548V0H9.08219V1.45548C10.8546 1.63661 12.3295 2.31583 13.5069 3.49315C14.6842 4.67047 15.3634 6.14536 15.5445 7.91781H17V9.08219H15.5445C15.3634 10.8546 14.6842 12.3295 13.5069 13.5069C12.3295 14.6842 10.8546 15.3634 9.08219 15.5445V17H7.91781ZM8.5 14.3995C10.1172 14.3995 11.5048 13.8206 12.6627 12.6627C13.8206 11.5048 14.3995 10.1172 14.3995 8.5C14.3995 6.8828 13.8206 5.49524 12.6627 4.33733C11.5048 3.17941 10.1172 2.60046 8.5 2.60046C6.8828 2.60046 5.49524 3.17941 4.33733 4.33733C3.17941 5.49524 2.60046 6.8828 2.60046 8.5C2.60046 10.1172 3.17941 11.5048 4.33733 12.6627C5.49524 13.8206 6.8828 14.3995 8.5 14.3995ZM8.5 11.411C7.68493 11.411 6.996 11.1296 6.43322 10.5668C5.87043 10.004 5.58904 9.31507 5.58904 8.5C5.58904 7.68493 5.87043 6.996 6.43322 6.43322C6.996 5.87043 7.68493 5.58904 8.5 5.58904C9.31507 5.58904 10.004 5.87043 10.5668 6.43322C11.1296 6.996 11.411 7.68493 11.411 8.5C11.411 9.31507 11.1296 10.004 10.5668 10.5668C10.004 11.1296 9.31507 11.411 8.5 11.411ZM8.5 10.2466C8.99163 10.2466 9.40563 10.0784 9.74201 9.74201C10.0784 9.40563 10.2466 8.99163 10.2466 8.5C10.2466 8.00837 10.0784 7.59437 9.74201 7.25799C9.40563 6.92161 8.99163 6.75342 8.5 6.75342C8.00837 6.75342 7.59437 6.92161 7.25799 7.25799C6.92161 7.59437 6.75342 8.00837 6.75342 8.5C6.75342 8.99163 6.92161 9.40563 7.25799 9.74201C7.59437 10.0784 8.00837 10.2466 8.5 10.2466Z"
      fill="#F5F5F5"
    />
  </svg>
);

const end = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 8.2875C7.95312 8.2875 8.33984 8.14229 8.66016 7.85188C8.98047 7.56146 9.14062 7.21083 9.14062 6.8C9.14062 6.38917 8.98047 6.03854 8.66016 5.74813C8.33984 5.45771 7.95312 5.3125 7.5 5.3125C7.04688 5.3125 6.66016 5.45771 6.33984 5.74813C6.01953 6.03854 5.85938 6.38917 5.85938 6.8C5.85938 7.21083 6.01953 7.56146 6.33984 7.85188C6.66016 8.14229 7.04688 8.2875 7.5 8.2875ZM7.5 15.3212C9.57812 13.6071 11.1133 12.0523 12.1055 10.6569C13.0977 9.26146 13.5938 8.0325 13.5938 6.97C13.5938 5.29833 13.0039 3.93125 11.8242 2.86875C10.6445 1.80625 9.20312 1.275 7.5 1.275C5.79688 1.275 4.35547 1.80625 3.17578 2.86875C1.99609 3.93125 1.40625 5.29833 1.40625 6.97C1.40625 8.0325 1.91406 9.26146 2.92969 10.6569C3.94531 12.0523 5.46875 13.6071 7.5 15.3212ZM7.5 17C4.98438 15.0592 3.10547 13.2565 1.86328 11.5919C0.621094 9.92729 0 8.38667 0 6.97C0 4.845 0.753906 3.15208 2.26172 1.89125C3.76953 0.630417 5.51563 0 7.5 0C9.48437 0 11.2305 0.630417 12.7383 1.89125C14.2461 3.15208 15 4.845 15 6.97C15 8.38667 14.3789 9.92729 13.1367 11.5919C11.8945 13.2565 10.0156 15.0592 7.5 17Z"
      fill="#F5F5F5"
    />
  </svg>
);

const arrow = (
  <svg
    width="8"
    height="32"
    viewBox="0 0 8 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.64645 31.3536C3.84171 31.5488 4.15829 31.5488 4.35355 31.3536L7.53554 28.1716C7.7308 27.9763 7.7308 27.6597 7.53554 27.4645C7.34027 27.2692 7.02369 27.2692 6.82843 27.4645L4 30.2929L1.17157 27.4645C0.976312 27.2692 0.659729 27.2692 0.464467 27.4645C0.269205 27.6597 0.269205 27.9763 0.464467 28.1716L3.64645 31.3536ZM3.5 2.18557e-08L3.5 31L4.5 31L4.5 -2.18557e-08L3.5 2.18557e-08Z"
      fill="#F7FAFF"
    />
  </svg>
);
